<div
  [class]="`flex flex-col gap-lg justify-between h-[calc(100vh-17.5rem)] ${!isRequestHeaderUiEnhancementEnabled() && 'h-[calc(100vh-9.5rem)]!'}`">
  <!--------------------- comment section ---------------------->
  <section
    class="overflow-y-auto my-lg grow"
    (scroll)="onScrollTop($event)"
    #commentsContainer>
    <!-------------- comment views ------------->
    @if (isUpdateCommentLoading()) {
      <div class="flex justify-center items-center h-full">
        <lib-loader [size]="'lg'" />
      </div>
    }

    @for (
      comment of comments();
      track comment.id;
      let isFirst = $first;
      let isLast = $last
    ) {
      <lib-discussion-comment-view
        [comment]="comment"
        [reactionList]="reactionList()"
        [isFirst]="isFirst"
        [hasLength]="!!comments().length"
        [isLast]="isLast"
        [isDeleteCommentLoading]="isDeleteCommentLoading()"
        [isReactionsLoading]="isReactionsLoading()"
        [commentReactions]="commentReactions()"
        [commentReactionsMeta]="commentReactionsMeta()"
        [showAllReactions]="showAllReactions()"
        [showAttachmentsOnly]="showAttachmentsOnly()"
        (toggleUserReactions)="toggleUserReactions($event)"
        (updateComment)="fillForm($event)"
        (deleteComment)="deleteComment($event)"
        (storeReact)="storeReact($event)"
        (deleteReact)="deleteReact($event)"
        (getCommentReactions)="getReactions($event)"
        (toggleEmojiTab)="getReactions($event)"
        (turnOffOutSideClick)="turnOffOutSideClick.emit($event)" />
    } @empty {
      @if (!isLoading()) {
        <lib-discussion-empty-state />
      }
    }
  </section>

  <!---------------------- discussion form ---------------------->
  @if (!showAttachmentsOnly()) {
    <section class="w-full">
      <lib-discussion-form
        [discussionFormGroup]="discussionFormGroup()"
        [initialAttachments]="initialAttachments()"
        [commentId]="selectedCommentId()"
        [triggerClearForm]="triggerClearForm()"
        (addComment)="addComment($event)"
        (updateComment)="updateComment($event)"
        (discardForm)="discardForm()" />
    </section>
  } @else {
    <section class="w-full">
      <lib-discussion-form
        [discussionFormGroup]="discussionFormGroup()"
        [initialAttachments]="initialAttachments()"
        [submitAttachmentsOnly]="true"
        (addComment)="addComment($event)" />
    </section>
  }
</div>
